const serializeJSON = <T>(value: T, callerName: string) => {
  try {
    return JSON.stringify(value);
  } catch (_e) {
    throw new Error(`${callerName}: Failed to serialize the value`);
  }
};

export default serializeJSON;
